<h3>    
    <mat-icon (click)="closeInfocard()">close</mat-icon>
    Onvoldoende credits
</h3>
<p>U beschikt niet over voldoende credits. Schaf extra credits aan.</p>

<button color="accent" mat-raised-button routerLink="/app/tarieven" (click)="closeInfocard()" >Extra credits aanschaffen</button>